/* eslint-disable camelcase */
import {
  Default as _, match,
} from '@nike/rcf-fp';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';

const OtherTenderType = ({
  tenderInfo,
  timezone
}) => {
  const {
    locale: { storeCurrency, storeLocale, momentFormat }, RL_BankTransfer, RL_GiftCertificate, RL_LLCard, RL_StoreCredit, RL_No, RL_Voucher, RL_Store, RL_Tran, RL_Date, RL_Time, Op, RL_Reg
  } = useSelector((state) => state);

  const localizeAmount = (tenderAmount) => currencyFormatter(storeLocale, storeCurrency, tenderAmount);

  const tenderByTranslation = (tender) => match(tender)(
    ['StoreCredit', RL_StoreCredit],
    ['LandLordCard', RL_LLCard],
    ['GiftCertificate', RL_GiftCertificate],
    ['Voucher', RL_Voucher],
    ['BankTransfer', RL_BankTransfer],
    [_, tender]
  );

  const tenderType = (tender) => match(tender)(
    [() => tender.Tender, tender.Tender?.SubTenderType ? tender.Tender?.SubTenderType : tender.Tender?.TenderType],
    [() => tender.TenderChange, tender.TenderChange?.SubTenderType ? tender.TenderChange?.SubTenderType : tender.TenderChange?.TenderType],
    [_, '']
  );

  return (
    <>
      {tenderInfo.Tender?.TenderType === 'StoreCredit' && (
      <>
        <article className="justify-between">
          <p>{RL_Store}</p><p>{tenderInfo?.LocationCode}</p>
        </article>
        <article className="justify-between">
          <p>{RL_Tran}</p><p>{tenderInfo?.SequenceNumber}</p>
        </article>
        <article className="justify-between">
          <p>{RL_Date}</p><p>{tenderInfo?.EndDateTime ? moment(tenderInfo?.EndDateTime).format(momentFormat) : ''}</p>
        </article>
        <article className="justify-between">
          <p>{RL_Time}</p><p>{tenderInfo?.EndDateTime ? moment(tenderInfo?.EndDateTime).tz(timezone).format('HH:mm:ss') : ''}</p>
        </article>
        <article className="justify-between">
          <p>{Op}</p><p>{tenderInfo?.Operator}</p>
        </article>
        <article className="justify-between">
          <p>{RL_Reg}</p><p>{tenderInfo?.TillID}</p>
        </article>
      </>
      )}

      <article className="justify-between">
        <p>{tenderByTranslation(tenderType(tenderInfo))}</p>
        {tenderInfo.Tender?.TypeCode === 'Sale' && <p>{localizeAmount(tenderInfo.Tender?.Amount?.Amount)}</p>}
        {(tenderInfo.TenderChange?.TypeCode === 'Refund' || tenderInfo.Tender?.TypeCode === 'Refund') && (
          <>
            <p>
              ({localizeAmount(tenderInfo.TenderChange?.TypeCode === 'Refund'
              ? tenderInfo.TenderChange?.Amount?.Amount
              : tenderInfo.Tender?.Amount?.Amount)})
            </p>
          </>
        )}
      </article>
      {(tenderInfo?.Tender?.StoredValueInstrument?.SerialNumber) && (
        <>
          <article className="justify-between">
            <p>{tenderByTranslation(tenderType(tenderInfo))} {RL_No || 'No.'} </p>
            <p>{tenderInfo?.Tender?.StoredValueInstrument?.SerialNumber}</p>
          </article>
        </>
      )}
      {(tenderInfo?.Tender?.Voucher?.SerialNumber) && (
      <>
        <article className="justify-between">
          <p className="pl2-sm">{RL_No || 'No.'} {tenderInfo?.Tender?.Voucher?.SerialNumber}</p>
        </article>
      </>
      )}
      <br /> <br />
    </>
  );
};

OtherTenderType.defaultProps = {
  tenderInfo: {},
  timezone: ''
};

OtherTenderType.propTypes = {
  tenderInfo: PropTypes.shape(),
  timezone: PropTypes.string
};

export default OtherTenderType;
